import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Stack } from "@mui/material";
import Accordion3SubSection from "./Accordion3SubSection";

const AccordionSection3 = () => {
  return (
    <Stack
      sx={{
        // border: "1px solid red",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Accordion
        sx={{
          width: {
            xl: "70%",
            lg: "90%",
            xs: "92%",
            background:
              "linear-gradient(to right, #eef6f5, #f3f4f4, #f7f5f2, #fff7ed)",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {/* for desktop */}
          <Stack
            sx={{
              display: { sm: "flex", xs: "none" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "21px",
                  lg: "21px",
                  md: "20px",
                  sm: "20px",
                  xs: "18px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Enterprise <span style={{ color: "#8dc642" }}>Custom Plans</span>
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "#333",
                fontSize: {
                  xl: "18px",
                  lg: "18px",
                  md: "16px",
                  sm: "16px",
                  xs: "14px",
                },
              }}
            >
              {" "}
              Enterprise Custom Plans offer tailored solutions for businesses
              with advanced needs, including flexible features, scalable
              pricing, and dedicated support.
            </Typography>
          </Stack>

          {/* for mobile */}
          <Stack
            sx={{
              display: { sm: "none", xs: "flex" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "20px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Enterprise <span style={{ color: "#8dc642" }}>Custom Plans</span>
            </Typography>
            <Typography component="span">
              {" "}
              Enterprise Plans offer flexibility, scalable pricing, and support.
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Accordion3SubSection />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default AccordionSection3;
